import { Column } from '@tanstack/react-table';
import { ReactNode } from 'react';
import { SearchableSelectOption } from '../SearchableSelect';
import { SearchFilter, SelectFilter } from './columnHelpers';

export type SearchFilterConfig = {
  columnId: string;
  kind: 'search';
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
};

export type SelectFilterConfig = {
  columnId: string;
  kind: 'select';
  selectedValues: string[];
  onChange: (values: string[]) => void;
  options: SearchableSelectOption[];
  placeholder: string;
  loading?: boolean;
};

export type ColumnFilterConfig =
  | SearchFilterConfig
  | SelectFilterConfig;

export function createColumnFilterRenderer<T>(
  configs: Array<ColumnFilterConfig>
) {
  const configMap = new Map(configs.map((config) => [config.columnId, config]));

  return (column: Column<T, unknown>): ReactNode => {
    const config = configMap.get(column.id);
    if (!config) return null;

    if (config.kind === 'search') {
      return (
        <SearchFilter
          value={config.value}
          onChange={config.onChange}
          placeholder={config.placeholder}
          column={column}
          onClearFilter={() => config.onChange('')}
        />
      );
    }

    return (
      <SelectFilter
        options={config.options}
        selectedValues={config.selectedValues}
        onChange={config.onChange}
        placeholder={config.placeholder}
        loading={config.loading}
        column={column}
        onClearFilter={() => config.onChange([])}
      />
    );
  };
}
